<template>
  <main class="sa-content">
    <div class="sa-card-large">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">Previous Prescription</h5>
        <button class="sa-btn-back" @click="backAction('end')">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-mob-cont">
      <ul>
        <li v-for="(n,i) in prescription" :key="i" class="sa-card sa-card-gray sa-card-noshadow">
          <div class="sa-card-list-box">
            <div class="sa-word-break">
              <div :ref="presDiag1" @click="openToggle(i)" :class="open1[i] ? 'active' : ''">
                <span :class="{ 'icon-plus sa-added-med': !open1[i], 'icon-minus sa-added-med': open1[i],}"></span>
              </div>
              {{n.drug_nm}}
            </div>
          </div>
          <div v-show="open1[i]">
            <hr />
            <div class="sa-row">
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Dose</label>
                  <span>{{n.dose}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Dose unit</label>
                  <span>{{n.dose_unit}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Route</label>
                  <span>{{n.route}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Frequency</label>
                  <span>{{n.freq_nm}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Duration</label>
                  <span>{{n.dur}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Duration unit</label>
                  <span>{{n.dur_unit}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>PRN</label>
                  <span>{{n.prn}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Indications</label>
                  <span>{{n.indications}}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Instructions</label>
                  <span>{{n.inst  }}</span>
                </div>
              </div>
              <div class="sa-col-xs6 sa-col-sm4 sa-col-md4 sa-col-lg4">
                <div class="sa-form-group">
                  <label>Scientific Name</label>
                  <span>{{n.scientific_name}}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      </div>
    </div>
  </main>
</template>
<script>
import { pro_url, oh_url } from "../../../config/endpoints";
export default {
  props: ["problems"],
  data() {
    return {
      i: null,
      open1: {},
      presDiag1: 0,
      presDiag: 0,
      open: {},
      prescription: []
    };
  },
  methods: {
    getPreviousPrescription(){
       let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/previousPrescription`,
          body: {
            apnt_id: this.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            this.prescription = response.data;
          }
        });
    },
   backAction: function(event) {
      // webview back button
      if (typeof window != undefined && window.ReactNativeWebView) {
        let data = {
          action: "end",
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      } else {
        this.$router.push('/appointments/doctor-details/'+this.$route.params.appid)
      }
    },
    openToggle(i) {
      let _self = this;
      let flag = !_self.open1[i];
      _self.$set(_self.open1, i, flag);
      _self.presDiag1 += 1;
    },
  },
  mounted(){
    this.getPreviousPrescription()
  }
};
</script>